import { useContext, useEffect, useState } from "react";
import { Button, Card, Col, Container, Row } from "react-bootstrap";
import { withTranslation } from "react-i18next";
import { useParams } from "react-router";
import Get from "../../api/Get";
import { GET_APPOINTMENT_BY_ID } from "../../api/Routes";
import DetalleCitaAnexos1 from "../../components/cita/DetalleCitaAnexos1";
import DetalleCitaAnexos2 from "../../components/cita/DetalleCitaAnexos2";
import DetalleCitaHorario from "../../components/cita/DetalleCitaHorario";
import DetalleCitaPaciente from "../../components/cita/DetalleCitaPaciente";
import ComponentModalErrorSever from "../../components/ComponentModalErrorSever";
import NoDataToShow from "../../components/NoDataToShow";
import { authContext } from "../../context/AuthContext";
import useCompanyType from "../../hook/useCompanyType";
import LoadingList from "../../loader/LoadingList";
import { compareDate } from "../../utils/compareDate";

function DetalleCita({t}){
    const {auth} = useContext(authContext)
    const {idParam} = useParams()
    const [founded, setFounded] = useState(true)
    const [loading, setLoading] = useState(true)
    const [cita, setCita] = useState(null)
    const [appointmentStatusText, setAppointmentStatusText] = useState('Esta cita se encuentra pendiente de aprobación')
    const companyType = useCompanyType()
    const [estado, setEstado] = useState(null)

    const [errorServer, setErrorServer] = useState(null)
    const [showModalServer, setShowModalServer] = useState(false)
    const handleCloseModalServer = () =>{
        setShowModalServer(false)
    }

    useEffect(()=>{
        if(idParam){
            Get({url: `${GET_APPOINTMENT_BY_ID}/${idParam}`, access_token: auth.data.access_token})
            .then(response=>{
                //console.log(response)
                let current_cita = response.data.data
                setCita(current_cita)

                let afterBefore = compareDate(current_cita.currentTime, current_cita.scheduleDTO.dateTimeEnd)                

                if(current_cita.appointmentStatus === 'Pendiente'){
                    setAppointmentStatusText('Esta cita se encuentra pendiente de aprobación')
                    setEstado("Pendiente")
                }else if(current_cita.appointmentStatus === 'Cancelada'){
                    setAppointmentStatusText('Esta cita ha sido cancelada')
                    setEstado("Cancelada")
                }else if(current_cita.appointmentStatus === "NoAtendida" || (afterBefore === "terminado" && current_cita.dataVideoCallList.length === 0)){
                    setAppointmentStatusText("Esta cita no ha sido atendida")
                    setEstado("NoAtendida")
                }
                setFounded(true)
                setLoading(false)
            }).catch(error => {
                setLoading(false)
                setShowModalServer(true)
                if(error.response){
                    setErrorServer(error.response)
                }
            })
        }
    },[])

    return (
        <>
            {
                loading ?
                <Container fluid><Row><Col><LoadingList texto={t('cargando_datos')}/></Col></Row></Container> :
                !founded ? <NoDataToShow text={t('url_no_valida')}/> :
                <Container fluid>
                    {
                        (estado=== 'Pendiente' || estado === 'Cancelada' || estado === 'NoAtendida') ?
                            <Row className="mt-5">
                                <Col xs="12" md={{span: 4, offset: 4}}>
                                    <Card>
                                        <Card.Body className="text-center">
                                            {appointmentStatusText}
                                            {
                                                estado === 'Pendiente' &&
                                                <div className="text-center">
                                                    <Button variant="link" onClick={e=>window.location.reload()}>Volver a intentar</Button>
                                                </div>
                                            }
                                        </Card.Body>
                                    </Card>
                                </Col>
                            </Row> :
                            <Row className="mt-5">
                                <Col xs="12" md="6" className="overflow-y-auto h-scrollbar h-100vh order-2 order-md-1">
                                    <DetalleCitaHorario cita={cita} />
                                    <div className="my-2"></div>
                                    <DetalleCitaPaciente companyType={companyType} cita={cita}/>
                                    <div className="my-2"></div>
                                    <DetalleCitaAnexos1 cita={cita} auth={auth} companyType={companyType} setShowModalServer={setShowModalServer}/>
                                </Col>
                                <Col xs="12" md="6" className="order-1 order-md-2">
                                    <DetalleCitaAnexos2 cita={cita} auth={auth} companyType={companyType}/>
                                </Col>
                            </Row>
                    }
                    
                </Container>
            }
            <ComponentModalErrorSever
                show={showModalServer}
                handleClose={handleCloseModalServer}
                error={errorServer}
            />
        </>
    )

}

export default withTranslation()(DetalleCita)